<template>
  <div v-if="years.length" class="col-span-12">
    <div v-for="year in years" :key="year" class="mb-4">
      <h3 class="font-medium mb-2">
        {{ year }}
        {{ year === eventYear ? "Daily Report" : "Comparison" }} Dates
      </h3>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <label :for="`report-start-${year}`">
          Start date
          <input
            :id="`report-start-${year}`"
            type="date"
            class="form-control mt-2"
            :value="windowFor(year).startDate"
            :required="Boolean(windowFor(year).endDate)"
            :max="windowFor(year).endDate || undefined"
            @input="updateDate(year, 'startDate', $event.target.value)"
          />
        </label>
        <label :for="`report-end-${year}`">
          End date
          <input
            :id="`report-end-${year}`"
            type="date"
            class="form-control mt-2"
            :value="windowFor(year).endDate"
            :required="Boolean(windowFor(year).startDate)"
            :min="windowFor(year).startDate || undefined"
            @input="updateDate(year, 'endDate', $event.target.value)"
          />
        </label>
      </div>
    </div>
    <p class="text-sm text-gray-600 mb-4">
      Dates include the entire day in Central Time. Reports compare days since
      each campaign started. Leave both dates blank until the campaign dates are
      known.
    </p>
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";

export default defineComponent({
  props: {
    eventYear: { type: String, required: true },
    reportingWindows: { type: Array, default: () => [] }
  },
  emits: ["update:reportingWindows"],
  setup(props, { emit }) {
    const years = computed(() =>
      /^\d{4}$/.test(props.eventYear) && Number(props.eventYear) >= 2022
        ? [props.eventYear, String(Number(props.eventYear) - 1)]
        : []
    );
    const windowFor = year =>
      props.reportingWindows.find(window => window.eventYear === year) || {
        eventYear: year,
        startDate: "",
        endDate: ""
      };
    const updateDate = (year, field, value) => {
      const windows = props.reportingWindows.map(window => ({ ...window }));
      let window = windows.find(window => window.eventYear === year);
      if (!window) {
        window = { ...windowFor(year) };
        windows.push(window);
      }
      window[field] = value;
      emit("update:reportingWindows", windows);
    };
    return { years, windowFor, updateDate };
  }
});
</script>
